import { sfChatConfig } from '../utils/sfChatConfig';

export const embedded_svc = window.embedded_svc;

const initESW = function (gslbBaseURL: string | null) {
	embedded_svc.settings.displayHelpButton = false;
	embedded_svc.settings.language = 'en-US';

	embedded_svc.settings.storageDomain = 'vizio.com';

	embedded_svc.settings.enabledFeatures = ['LiveAgent'];
	embedded_svc.settings.entryFeature = 'LiveAgent';

	embedded_svc.init(
		sfChatConfig.sfDomain,
		sfChatConfig.sfSiteDomain,
		gslbBaseURL,
		sfChatConfig.baseToken,
		sfChatConfig.deploymentTitle,
		{
			baseLiveAgentContentURL: sfChatConfig.baseLiveAgentContentURL,
			deploymentId: sfChatConfig.deploymentId,
			buttonId: sfChatConfig.buttonId,
			baseLiveAgentURL: sfChatConfig.baseLiveAgentURL,
			eswLiveAgentDevName: sfChatConfig.eswLiveAgentDevName,
			isOfflineSupportEnabled: sfChatConfig.isOfflineSupportEnabled
		}
	);
};

if (!window.embedded_svc) {
	const s = document.createElement('script');
	s.setAttribute('src', sfChatConfig.sfScriptSrc);
	s.onload = function () {
		initESW(null);
	};
	document.body.appendChild(s);
} else {
	initESW(sfChatConfig.sfScriptDomain);
}

export interface sfPreChatData {
	firstName: string;
	lastName: string;
	email: string;
	notes: string;
	phoneNum: string;
	serialNum: string | null;
	modelNum: string | null;
	isInfoUpdated: boolean;
}

export const initiateSupportChat = (preChatInfo: sfPreChatData) => {
	embedded_svc.settings.prepopulatedPrechatFields = {
		FirstName: preChatInfo.firstName,
		LastName: preChatInfo.lastName,
		Email: preChatInfo.email,
		Subject: preChatInfo.notes,
		Phone: preChatInfo.phoneNum,
		Serial_Number__c: preChatInfo.serialNum,
		Model_Number__c: preChatInfo.modelNum
	};

	try {
		embedded_svc.liveAgentAPI.startChat({
			directToAgentRouting: {
				buttonId: sfChatConfig.buttonId,
				fallback: true
			},
			extraPrechatInfo: [
				{
					entityName: 'Case',
					showOnCreate: false,
					displayToAgent: true,
					saveToTranscript: 'CaseId',
					entityFieldMaps: [
						{
							isExactMatch: false,
							fieldName: 'Subject',
							doFind: false,
							doCreate: true,
							label: 'Subject'
						}
					]
				}
			],
			extraPrechatFormDetails: [
				{
					label: 'Serial Number',
					value: preChatInfo.serialNum ? preChatInfo.serialNum : null,
					displayToAgent: true,
					transcriptFields: ['Serial_Number__c']
				},
				{
					label: 'Model Number',
					value: preChatInfo.modelNum ? preChatInfo.modelNum : null,
					displayToAgent: true,
					transcriptFields: ['Model_Number__c']
				},
				{
					label: 'First Name',
					value: preChatInfo.firstName,
					displayToAgent: true,
					transcriptFields: ['First_Name__c']
				},
				{
					label: 'Last Name',
					value: preChatInfo.lastName,
					displayToAgent: true,
					transcriptFields: ['Last_Name__c']
				},
				{
					label: 'Phone',
					value: preChatInfo.phoneNum,
					displayToAgent: true,
					transcriptFields: ['Phone__c']
				},
				{
					label: 'Email',
					value: preChatInfo.email,
					displayToAgent: true,
					transcriptFields: ['Email__c']
				},
				{
					label: 'Update Info',
					value: preChatInfo.isInfoUpdated,
					displayToAgent: true,
					transcriptFields: ['Update_Info__c']
				}
			]
		});
	} catch (error) {
		console.error('Salesforce Chat Error', error);
	}
};
